import { render, staticRenderFns } from "./KidsModal.vue?vue&type=template&id=6aa8154a&"
import script from "./KidsModal.vue?vue&type=script&lang=js&"
export * from "./KidsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports